import React from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide06Impact({
  index
}: SlideProps) {
  const pillars = [{
    title: 'More Reach',
    description: 'Engage participants and non-participants.'
  }, {
    title: 'More Consumption',
    description: 'Busy HCPs can access content in 3–5 minute episodes.'
  }, {
    title: 'More Insights',
    description: 'Track engagement by topic and episode.'
  }, {
    title: 'More Value',
    description: 'Extend the lifespan of every DERMX webinar.'
  }];
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] flex flex-col" data-id="element-160">
      <div className="flex-1 p-[clamp(2rem,4vw,4rem)]" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="mb-[clamp(2rem,4vw,3rem)]" data-id="element-162">
          <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,4vw,3.5rem)] leading-[1.1]" data-id="element-163">
            <span className="text-[var(--brand-green-light)]" data-id="element-164">One</span> webinar
            becomes a multi-week engagement journey
          </h2>
        </motion.div>

        {/* Value pillars */}
        <div className="grid grid-cols-2 gap-[clamp(1.5rem,3vw,3rem)]" data-id="element-165">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3 + idx * 0.1,
          duration: 0.6
        }} className="bg-[var(--surface)] rounded-2xl p-[clamp(1.5rem,3vw,3rem)]" data-id="element-166">
              <h3 className="text-[var(--brand-green)] font-bold text-[clamp(1.5rem,2.5vw,2.25rem)] mb-[clamp(0.75rem,1.5vw,1.25rem)]" data-id="element-167">
                {pillar.title}
              </h3>
              <p className="text-[var(--fg)] text-[clamp(1rem,1.75vw,1.5rem)] leading-snug" data-id="element-168">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* Bottom banner */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.8,
      duration: 0.6
    }} className="bg-[var(--brand-green)] px-[clamp(2rem,4vw,4rem)] py-[clamp(2rem,3vw,3rem)]" data-id="element-169">
        <div className="flex justify-between items-center" data-id="element-170">
          <p className="text-white font-bold text-[clamp(1.25rem,2.5vw,2.25rem)]" data-id="element-171">
            From webinar to series. From one event to weeks of engagement.
          </p>
          <span className="text-white/40 text-sm" data-id="element-172">{index + 1}</span>
        </div>
        <p className="text-white/60 text-[clamp(0.75rem,1.125vw,0.875rem)] mt-4" data-id="element-173">
          Proposal concept for DERMX | LEO Pharma
        </p>
      </motion.div>
    </div>;
}